export const getTabRelativeURI = (
  roundIds: number[],
  currentPage: string,
  eventId: string | undefined,
  clubId: string | undefined,
  currentRound: number,
  tabToSet: number
) => {
  const numRounds = roundIds.length;
  const roundIdToSet = roundIds && roundIds[tabToSet - 1] ? roundIds[tabToSet - 1] : null;

  if (
    (tabToSet === 0 && currentPage === 'setup') ||
    (tabToSet === numRounds + 1 && currentPage === 'complete') ||
    (tabToSet > 0 &&
      tabToSet <= numRounds &&
      currentPage === 'round' &&
      currentRound === roundIdToSet)
  ) {
    return;
  }

  return Number(eventId)
    ? tabToSet === 0
      ? `/staff/club/${clubId}/event/${eventId}/setup/start`
      : tabToSet <= numRounds
      ? `/staff/club/${clubId}/event/${eventId}/round/${roundIdToSet}/setup`
      : currentPage !== 'complete' && tabToSet > numRounds
      ? `/staff/club/${clubId}/event/${eventId}/complete`
      : `/staff/club/${clubId}/event/new/setup/start`
    : `/staff/club/${clubId}/event/new/setup/start`;
};
